import { Component} from "@angular/core";
import { SharedService } from "../shared/service";
import { AuthService } from "../shared/auth.service";

@Component({
  templateUrl: './dashboard.content.html'
})
export class DashboardContent {

  constructor(public shared: SharedService, private authService: AuthService) {

  }

  isFull = this.authService.isFull;

  isAdmin = this.authService.isAdmin;

  isConsultant = this.authService.isConsultant;

  isCertify = this.authService.isCertify;
}
